var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSuitableForInfants = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 30 27"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#77838D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M11.188 13.9c.195 0 .354.141.354.316M10.833 14.216c0-.175.159-.316.354-.316"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#77838D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M11.187 14.53c-.195 0-.354-.141-.354-.315M11.542 14.215c0 .174-.159.315-.354.315M17.563 13.9c.195 0 .354.141.354.316M17.208 14.216c0-.175.159-.316.354-.316"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#77838D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M17.562 14.53c-.195 0-.354-.141-.354-.315M17.917 14.215c0 .174-.159.315-.355.315"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#77838D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M22.52 12.955h-.012c-1.089-3.186-4.39-5.363-8.133-5.363s-7.044 2.177-8.133 5.363H6.23c-1.369 0-2.479.987-2.479 2.205s1.11 2.206 2.48 2.206h.012c1.089 3.185 4.39 5.362 8.133 5.362s7.044-2.177 8.133-5.362h.013c1.369 0 2.479-.988 2.479-2.206s-1.11-2.205-2.48-2.205",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  stroke: "#77838D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M17.542 18.31c-.806.802-1.958 1.26-3.167 1.26-1.21 0-2.362-.458-3.168-1.26M16.725 4.447c1.579.933 2.273 2.683 1.7 4.291-.571 1.608-2.27 2.684-4.166 2.639-1.894-.046-3.526-1.202-4-2.835"
})));
export default SvgSuitableForInfants;